import { render, staticRenderFns } from "./Achievement_detailsNel.vue?vue&type=template&id=9a1bed4a&scoped=true"
import script from "./Achievement_detailsNel.vue?vue&type=script&lang=js"
export * from "./Achievement_detailsNel.vue?vue&type=script&lang=js"
import style0 from "./Achievement_detailsNel.vue?vue&type=style&index=0&id=9a1bed4a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a1bed4a",
  null
  
)

export default component.exports